var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.996,
    height: 20.006
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 398",
    d: "M14 20.001H1.992a2 2 0 01-1.994-2v-16a2 2 0 011.994-2h7.98l6.021 6.022v11.978a2 2 0 01-1.993 2zm-9.5-5a.5.5 0 100 1h7.006a.5.5 0 000-1zm0-2a.5.5 0 100 1h7.006a.5.5 0 000-1zm0-2a.5.5 0 000 1h7.006a.5.5 0 000-1zm4.492-9v5h5l-5-5z",
    fill: "#2693ff"
  })));
}
export default SvgFile;